import {
  HOME_URL,
  JOBS_URL,
  TEMPLATES_URL,
  VEHICLES_URL,
  EQUIPMENTS_URL,
  MAINTENANCE_URL,
  INSPECTIONS_URL,
  ISSUES_URL,
  VENDORS_URL,
  EMPLOYEES_URL,
  SERVICES_URL,
  SERVICE_PROGRAMMES_URL,
  SERVICE_TASKS_URL,
  JOB_SCHEDULES_URL,
  MACHINE_URL,
  PURCHASE_URL,
  MILL_ORDERS_URL
} from '@/utils/constants'
import {
  JobsIcon,
  JobScheduleIcon,
  TemplatesIcon,
  VehiclesIcon,
  OverviewIcon,
  EquipmentsIcon,
  MaintenanceIcon,
  InspectionIcon,
  IssuesIcon,
  OrdersIcon,
  VendorsIcon,
  EmployeesIcon,
  MachinesIcon
} from '@/assets'

export const routeAssets: { [key: string]: string } = {
  [JOBS_URL]: JobsIcon,
  [JOB_SCHEDULES_URL]: JobScheduleIcon,
  [HOME_URL]: OverviewIcon,
  [TEMPLATES_URL]: TemplatesIcon,
  [VEHICLES_URL]: VehiclesIcon,
  [MACHINE_URL]: MachinesIcon,
  [EQUIPMENTS_URL]: EquipmentsIcon,
  [MAINTENANCE_URL]: MaintenanceIcon,
  [SERVICES_URL]: MaintenanceIcon,
  [SERVICE_PROGRAMMES_URL]: MaintenanceIcon,
  [SERVICE_TASKS_URL]: MaintenanceIcon,
  [INSPECTIONS_URL]: InspectionIcon,
  [MILL_ORDERS_URL]: OrdersIcon,
  [PURCHASE_URL]: OrdersIcon,
  [ISSUES_URL]: IssuesIcon,
  [VENDORS_URL]: VendorsIcon,
  [EMPLOYEES_URL]: EmployeesIcon
}
